import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { NgbModalConfig, NgbModal, NgbCarouselConfig } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { AuthService } from '../auth/auth.service';
import * as moment from "moment";

@Component({
  selector: 'app-earning-dashboard',
  templateUrl: './earning-dashboard.component.html',
  styleUrls: ['./earning-dashboard.component.scss']
})
export class EarningDashboardComponent implements OnInit {
  Week: boolean = false;
  month: boolean = false;
  Today: boolean = false;
  all: boolean = true;
  startToday: any;
  commissionCount: any;
  AepsBCommission: any;
  AepsCommission: any;
  AepsGTV:any;
  TdsAeps: any;
  DmtBcom: any;
  Dmtcom: any;
  dmtTds: any;
  mobileBcom: any;
  mobilecom: any;
  mobileTds: any;
  dthBcom: any;
  dthcom: any;
  dthTds: any;
  mAtmTBcom: any;
  mAtmTcom: any;
  mAtmTTds: any;
  weekendDate: string;
  weekstartDateFormat: string;
  MonthEnddate: string;
  MonthStartDate: string;
  totalBcomm: any;
  totalcomm: any;
  totalTds: any;
  dthGTV: any;
  mobileGTV: number;
  DmtGTV: number;
  mAtmGTV: number;
  totalGTVCurrectDay: any;
  totalGTVLastWeek: any;
  totalGTVLastMonth: number;
  mobileDiscount: any;
  dthDiscount: any;
  APGTV: number;
  APCommission: any;
  APBCommission: any;
  TdsAP: any;
  BbpsBCommission: any;
  BbpsCommission: any;
  BbpsGTV: number;
  TdsBbps: any;
  CMSBCommission: any;
  CMSGTV: number;
  CMSTds: any;
  CMSCommission: any;
  constructor(private dialog: MatDialog,private router:Router,private toastr:ToastrService, private spinner: NgxSpinnerService,configngb: NgbModalConfig,private modalService: NgbModal,private auth: AuthService,config: NgbCarouselConfig,private ngxService: NgxUiLoaderService) {
    // this.getTicketToken();
    config.interval = 1000;
    config.keyboard = true;
    config.pauseOnHover = true;

    configngb.backdrop = 'static';
    configngb.keyboard = false;
   
  }
  ngOnInit(): void {
    this.getAllCommissionDistributorByDateApi();

  }
  goToExcel(){
    this.router.navigate(['/earning-report-export']);
  }

  /* ---------- presentation only (reference: dashboard-reference.html) ----------
     One segmented control drives BOTH legacy tab callbacks so the service
     breakdown and the totals can never go out of sync. Period labels keep the
     exact strings dailyReport()/dailyReportTotal() already switch on. */
  period: string = 'Today';
  setPeriod(value: string) {
    if (this.period === value) { return; }
    this.period = value;
    this.dailyReport(value);
    this.dailyReportTotal(value);
  }
  get periodGtv() {
    if (this.period === 'Last 7 Days') { return this.totalGTVLastWeek; }
    if (this.period === 'Current Month') { return this.totalGTVLastMonth; }
    return this.totalGTVCurrectDay;
  }
  get periodCaption(): string {
    if (this.period === 'Last 7 Days') {
      return moment().subtract(7, 'days').format('D MMM') + ' – ' + moment().format('D MMM YYYY');
    }
    if (this.period === 'Current Month') {
      return moment().startOf('month').format('D MMM') + ' – ' + moment().format('D MMM YYYY');
    }
    return moment().format('dddd, D MMMM YYYY');
  }
  get serviceRows() {
    return [
      { name: 'AePS', gtv: this.AepsGTV, before: this.AepsBCommission, tds: this.TdsAeps, net: this.AepsCommission, discount: null },
      { name: 'Aadhaar Pay', gtv: this.APGTV, before: this.APBCommission, tds: this.TdsAP, net: this.APCommission, discount: null },
      { name: 'DMT', gtv: this.DmtGTV, before: this.DmtBcom, tds: this.dmtTds, net: this.Dmtcom, discount: null },
      { name: 'Mobile recharge', gtv: this.mobileGTV, before: this.mobileBcom, tds: this.mobileTds, net: this.mobilecom, discount: this.mobileDiscount },
      { name: 'DTH recharge', gtv: this.dthGTV, before: this.dthBcom, tds: this.dthTds, net: this.dthcom, discount: this.dthDiscount },
      { name: 'Micro ATM', gtv: this.mAtmGTV, before: this.mAtmTBcom, tds: this.mAtmTTds, net: this.mAtmTcom, discount: null },
      { name: 'BBPS', gtv: this.BbpsGTV, before: this.BbpsBCommission, tds: this.TdsBbps, net: this.BbpsCommission, discount: null },
      { name: 'CMS', gtv: this.CMSGTV, before: this.CMSBCommission, tds: this.CMSTds, net: this.CMSCommission, discount: null }
    ];
  }
  /////////////////////////////////EARNING APIs/////////////////////////////////
getAllCommissionDistributorByDateApi(){
  var startDate = new Date();
  this.startToday=moment(startDate).format("YYYY-MM-DD");

    this.auth.getAllCommissionDistributorByDate(this.startToday,this.startToday).subscribe(
      (data: any) => {
        if(data.status_code==1){
          this.commissionCount=data.object;

          this.AepsBCommission=this.commissionCount.aeps.commissionBeforeTDS;
          this.AepsCommission=this.commissionCount.aeps.commissionAfterTdsDecduction;
          this.AepsGTV= (((this.commissionCount.aeps.totalAmount)+((this.commissionCount.aeps.totalAmountNeg)*-1))-this.commissionCount.aeps.serviceCharges)
          this.TdsAeps=this.commissionCount.aeps.tdsAmount;

          this.DmtBcom=this.commissionCount.dmt.commissionBeforeTDS
          this.Dmtcom=this.commissionCount.dmt.commissionAfterTdsDecduction;
          this.DmtGTV=(((this.commissionCount.dmt.totalAmount)+((this.commissionCount.dmt.totalAmountNeg)*-1))-this.commissionCount.dmt.serviceCharges)
          this.dmtTds=this.commissionCount.dmt.tdsAmount

          this.mobileBcom=this.commissionCount.mobileRecharge.commissionBeforeTDS
          this.mobilecom=this.commissionCount.mobileRecharge.commissionAfterTdsDecduction;
          this.mobileGTV=(((this.commissionCount.mobileRecharge.totalAmount)+((this.commissionCount.mobileRecharge.totalAmountNeg)*-1))-this.commissionCount.mobileRecharge.serviceCharges)
          this.mobileTds=this.commissionCount.mobileRecharge.tdsAmount
          this.mobileDiscount=this.commissionCount.mobileRecharge.discountAmount


          this.dthBcom=this.commissionCount.dthRecharge.commissionBeforeTDS
          this.dthcom=this.commissionCount.dthRecharge.commissionAfterTdsDecduction;
          this.dthGTV=(((this.commissionCount.dthRecharge.totalAmount)+((this.commissionCount.dthRecharge.totalAmountNeg)*-1))-this.commissionCount.dthRecharge.serviceCharges)
          this.dthTds=this.commissionCount.dthRecharge.tdsAmount
          this.dthDiscount=this.commissionCount.dthRecharge.discountAmount


          this.mAtmTBcom=this.commissionCount.microatm_cash_withdrawl.commissionBeforeTDS
          this.mAtmTcom=this.commissionCount.microatm_cash_withdrawl.commissionAfterTdsDecduction;
          this.mAtmGTV=(((this.commissionCount.microatm_cash_withdrawl.totalAmount)+((this.commissionCount.microatm_cash_withdrawl.totalAmountNeg)*-1))-this.commissionCount.microatm_cash_withdrawl.serviceCharges)
          this.mAtmTTds=this.commissionCount.microatm_cash_withdrawl.tdsAmount;

          this.APBCommission=this.commissionCount.aadharpay.commissionBeforeTDS;
          this.APCommission=this.commissionCount.aadharpay.commissionAfterTdsDecduction;
          this.APGTV= this.commissionCount.aadharpay.totalAmount+this.commissionCount.aadharpay.serviceCharges;
          this.TdsAP=this.commissionCount.aadharpay.tdsAmount;
          // transactionAmount+serviceCharges
          this.BbpsBCommission=this.commissionCount.bbps.commissionBeforeTDS;
          this.BbpsCommission=this.commissionCount.bbps.commissionAfterTdsDecduction;
          this.BbpsGTV= (((this.commissionCount.bbps.totalAmount)+((this.commissionCount.bbps.totalAmountNeg)*-1))-this.commissionCount.bbps.serviceCharges)
          this.TdsBbps=this.commissionCount.bbps.tdsAmount;


          this.CMSBCommission=this.commissionCount.cms.commissionBeforeTDS;
          this.CMSCommission=this.commissionCount.cms.commissionAfterTdsDecduction;
          this.CMSGTV= (((this.commissionCount.cms.totalAmount)+((this.commissionCount.cms.totalAmountNeg)*-1))-this.commissionCount.cms.serviceCharges)
          this.CMSTds=this.commissionCount.cms.tdsAmount;


          this.totalBcomm =this.commissionCount.totalCommissionBeforeTDS
          this.totalcomm =this.commissionCount.totalCommissionAfterTdsDecduction
          this.totalTds =this.commissionCount.totalTdsAmount
          
          this.totalGTVCurrectDay=this.AepsGTV+this.DmtGTV+this.mobileGTV+this.dthGTV+this.mAtmGTV+this.APGTV+this.BbpsGTV+this.CMSGTV;

        }
        else{
          if(data.error.message=="No Session Data Found" || data.error.message=="Invalid Authentication Token"){
            this.router.navigate(['']);
            localStorage.clear();
          }
          this.toastr.error(data.error.message);
        }
      
      },
      (errorData) => {}
    );
}

  dailyReport(value){
    if(value=='Today'){
      var startDate = new Date();
      this.startToday=moment(startDate).format("YYYY-MM-DD");
      console.log("today::::::",this.startToday)
      this.auth.getAllCommissionDistributorByDate(this.startToday,this.startToday).subscribe(
        (data: any) => {
          if(data.status_code==1){
          this.commissionCount=data.object
          this.AepsBCommission=this.commissionCount.aeps.commissionBeforeTDS;
          this.AepsCommission=this.commissionCount.aeps.commissionAfterTdsDecduction;
          this.AepsGTV= (((this.commissionCount.aeps.totalAmount)+((this.commissionCount.aeps.totalAmountNeg)*-1))-this.commissionCount.aeps.serviceCharges)
          this.TdsAeps=this.commissionCount.aeps.tdsAmount;
  
          this.DmtBcom=this.commissionCount.dmt.commissionBeforeTDS
          this.Dmtcom=this.commissionCount.dmt.commissionAfterTdsDecduction;
          this.DmtGTV=(((this.commissionCount.dmt.totalAmount)+((this.commissionCount.dmt.totalAmountNeg)*-1))-this.commissionCount.dmt.serviceCharges)
          this.dmtTds=this.commissionCount.dmt.tdsAmount
  
          this.mobileBcom=this.commissionCount.mobileRecharge.commissionBeforeTDS
          this.mobilecom=this.commissionCount.mobileRecharge.commissionAfterTdsDecduction;
          this.mobileGTV=(((this.commissionCount.mobileRecharge.totalAmount)+((this.commissionCount.mobileRecharge.totalAmountNeg)*-1))-this.commissionCount.mobileRecharge.serviceCharges)
          this.mobileTds=this.commissionCount.mobileRecharge.tdsAmount
          this.mobileDiscount=this.commissionCount.mobileRecharge.discountAmount
  
  
          this.dthBcom=this.commissionCount.dthRecharge.commissionBeforeTDS
          this.dthcom=this.commissionCount.dthRecharge.commissionAfterTdsDecduction;
          this.dthGTV=(((this.commissionCount.dthRecharge.totalAmount)+((this.commissionCount.dthRecharge.totalAmountNeg)*-1))-this.commissionCount.dthRecharge.serviceCharges)
          this.dthTds=this.commissionCount.dthRecharge.tdsAmount
          this.dthDiscount=this.commissionCount.dthRecharge.discountAmount
  
          this.mAtmTBcom=this.commissionCount.microatm_cash_withdrawl.commissionBeforeTDS
          this.mAtmTcom=this.commissionCount.microatm_cash_withdrawl.commissionAfterTdsDecduction;
          this.mAtmGTV=(((this.commissionCount.microatm_cash_withdrawl.totalAmount)+((this.commissionCount.microatm_cash_withdrawl.totalAmountNeg)*-1))-this.commissionCount.microatm_cash_withdrawl.serviceCharges)
          this.mAtmTTds=this.commissionCount.microatm_cash_withdrawl.tdsAmount;
  
          this.APBCommission=this.commissionCount.aadharpay.commissionBeforeTDS;
            this.APCommission=this.commissionCount.aadharpay.commissionAfterTdsDecduction;
            this.APGTV= this.commissionCount.aadharpay.totalAmount+this.commissionCount.aadharpay.serviceCharges;
            this.TdsAP=this.commissionCount.aadharpay.tdsAmount;
  
            this.BbpsBCommission=this.commissionCount.bbps.commissionBeforeTDS;
            this.BbpsCommission=this.commissionCount.bbps.commissionAfterTdsDecduction;
            this.BbpsGTV= (((this.commissionCount.bbps.totalAmount)+((this.commissionCount.bbps.totalAmountNeg)*-1))-this.commissionCount.bbps.serviceCharges)
            this.TdsBbps=this.commissionCount.bbps.tdsAmount;
           
            this.CMSBCommission=this.commissionCount.cms.commissionBeforeTDS;
            this.CMSCommission=this.commissionCount.cms.commissionAfterTdsDecduction;
            this.CMSGTV= (((this.commissionCount.cms.totalAmount)+((this.commissionCount.cms.totalAmountNeg)*-1))-this.commissionCount.cms.serviceCharges)
            this.CMSTds=this.commissionCount.cms.tdsAmount;
  
  
          console.log("this.dthTds+this.mobileTds::::::",this.dthTds,this.mobileTds,(this.dthTds+this.mobileTds));
          }
          else{
            if(data.error.message=="No Session Data Found" || data.error.message=="Invalid Authentication Token"){
              this.router.navigate(['']);
              localStorage.clear();
            }
            this.toastr.error(data.error.message);
          }
        
        },
        (errorData) => {}
      );
    }
    else if(value=='Last 7 Days'){
    
      var end = new Date();
      this.weekendDate = moment(end).format("YYYY-MM-DD");
  
      var startDate = new Date();
      startDate.setDate(end.getDate()-7)
      this.weekstartDateFormat = moment(startDate).format("YYYY-MM-DD");
     
       console.log("todaydate==",this.weekstartDateFormat,"yest:::",this.weekendDate)
       this.auth.getAllCommissionDistributorByDate(this.weekstartDateFormat,this.weekendDate).subscribe(
        (data: any) => {
          if(data.status_code==1){
          this.commissionCount=data.object
            this.AepsBCommission=this.commissionCount.aeps.commissionBeforeTDS;
            this.AepsCommission=this.commissionCount.aeps.commissionAfterTdsDecduction;
            this.AepsGTV= (((this.commissionCount.aeps.totalAmount)+((this.commissionCount.aeps.totalAmountNeg)*-1))-this.commissionCount.aeps.serviceCharges)
            this.TdsAeps=this.commissionCount.aeps.tdsAmount;
  
            this.DmtBcom=this.commissionCount.dmt.commissionBeforeTDS
            this.Dmtcom=this.commissionCount.dmt.commissionAfterTdsDecduction;
            this.DmtGTV=(((this.commissionCount.dmt.totalAmount)+((this.commissionCount.dmt.totalAmountNeg)*-1))-this.commissionCount.dmt.serviceCharges)
            this.dmtTds=this.commissionCount.dmt.tdsAmount
  
            this.mobileBcom=this.commissionCount.mobileRecharge.commissionBeforeTDS
            this.mobilecom=this.commissionCount.mobileRecharge.commissionAfterTdsDecduction;
            this.mobileGTV=(((this.commissionCount.mobileRecharge.totalAmount)+((this.commissionCount.mobileRecharge.totalAmountNeg)*-1))-this.commissionCount.mobileRecharge.serviceCharges)
            this.mobileTds=this.commissionCount.mobileRecharge.tdsAmount
            this.mobileDiscount=this.commissionCount.mobileRecharge.discountAmount
  
  
            this.dthBcom=this.commissionCount.dthRecharge.commissionBeforeTDS
            this.dthcom=this.commissionCount.dthRecharge.commissionAfterTdsDecduction;
            this.dthGTV=(((this.commissionCount.dthRecharge.totalAmount)+((this.commissionCount.dthRecharge.totalAmountNeg)*-1))-this.commissionCount.dthRecharge.serviceCharges)
            this.dthTds=this.commissionCount.dthRecharge.tdsAmount
            this.dthDiscount=this.commissionCount.dthRecharge.discountAmount
  
            this.mAtmTBcom=this.commissionCount.microatm_cash_withdrawl.commissionBeforeTDS
            this.mAtmTcom=this.commissionCount.microatm_cash_withdrawl.commissionAfterTdsDecduction;
            this.mAtmGTV=(((this.commissionCount.microatm_cash_withdrawl.totalAmount)+((this.commissionCount.microatm_cash_withdrawl.totalAmountNeg)*-1))-this.commissionCount.microatm_cash_withdrawl.serviceCharges)
            this.mAtmTTds=this.commissionCount.microatm_cash_withdrawl.tdsAmount;
  
            this.APBCommission=this.commissionCount.aadharpay.commissionBeforeTDS;
            this.APCommission=this.commissionCount.aadharpay.commissionAfterTdsDecduction;
            this.APGTV= this.commissionCount.aadharpay.totalAmount+this.commissionCount.aadharpay.serviceCharges;
            this.TdsAP=this.commissionCount.aadharpay.tdsAmount;
  
            this.BbpsBCommission=this.commissionCount.bbps.commissionBeforeTDS;
            this.BbpsCommission=this.commissionCount.bbps.commissionAfterTdsDecduction;
            this.BbpsGTV= (((this.commissionCount.bbps.totalAmount)+((this.commissionCount.bbps.totalAmountNeg)*-1))-this.commissionCount.bbps.serviceCharges)
            this.TdsBbps=this.commissionCount.bbps.tdsAmount;
  
            this.CMSBCommission=this.commissionCount.cms.commissionBeforeTDS;
            this.CMSCommission=this.commissionCount.cms.commissionAfterTdsDecduction;
            this.CMSGTV= (((this.commissionCount.cms.totalAmount)+((this.commissionCount.cms.totalAmountNeg)*-1))-this.commissionCount.cms.serviceCharges)
            this.CMSTds=this.commissionCount.cms.tdsAmount;
  
  
          }
          else{
            if(data.error.message=="No Session Data Found" || data.error.message=="Invalid Authentication Token"){
              this.router.navigate(['']);
              localStorage.clear();
            }
            this.toastr.error(data.error.message);
          }
        
        },
        (errorData) => {}
      );
    }
    else if(value=='Current Month'){
      var currentdate = new Date();
      var cur_month = currentdate.getMonth() + 1;
      var cur_year = currentdate.getFullYear();
  
      this.MonthEnddate= moment(currentdate).format("YYYY-MM-DD");
      var std=cur_year+"-"+"0"+cur_month+"-"+'01'
      this.MonthStartDate=moment(std).format("YYYY-MM-DD")
      console.log(this.MonthEnddate,std,this.MonthStartDate);
  
      this.auth.getAllCommissionDistributorByDate(this.MonthStartDate,this.MonthEnddate).subscribe(
        (data: any) => {
          if(data.status_code==1){
          this.commissionCount=data.object
          this.AepsBCommission=this.commissionCount.aeps.commissionBeforeTDS;
          this.AepsCommission=this.commissionCount.aeps.commissionAfterTdsDecduction;
          this.AepsGTV= (((this.commissionCount.aeps.totalAmount)+((this.commissionCount.aeps.totalAmountNeg)*-1))-this.commissionCount.aeps.serviceCharges)
          this.TdsAeps=this.commissionCount.aeps.tdsAmount;
  
          this.DmtBcom=this.commissionCount.dmt.commissionBeforeTDS
          this.Dmtcom=this.commissionCount.dmt.commissionAfterTdsDecduction;
          this.DmtGTV=(((this.commissionCount.dmt.totalAmount)+((this.commissionCount.dmt.totalAmountNeg)*-1))-this.commissionCount.dmt.serviceCharges)
          this.dmtTds=this.commissionCount.dmt.tdsAmount
  
          this.mobileBcom=this.commissionCount.mobileRecharge.commissionBeforeTDS
            this.mobilecom=this.commissionCount.mobileRecharge.commissionAfterTdsDecduction;
            this.mobileGTV=(((this.commissionCount.mobileRecharge.totalAmount)+((this.commissionCount.mobileRecharge.totalAmountNeg)*-1))-this.commissionCount.mobileRecharge.serviceCharges)
            this.mobileTds=this.commissionCount.mobileRecharge.tdsAmount
            this.mobileDiscount=this.commissionCount.mobileRecharge.discountAmount
  
  
            this.dthBcom=this.commissionCount.dthRecharge.commissionBeforeTDS
            this.dthcom=this.commissionCount.dthRecharge.commissionAfterTdsDecduction;
            this.dthGTV=(((this.commissionCount.dthRecharge.totalAmount)+((this.commissionCount.dthRecharge.totalAmountNeg)*-1))-this.commissionCount.dthRecharge.serviceCharges)
            this.dthTds=this.commissionCount.dthRecharge.tdsAmount
            this.dthDiscount=this.commissionCount.dthRecharge.discountAmount
  
          this.mAtmTBcom=this.commissionCount.microatm_cash_withdrawl.commissionBeforeTDS
          this.mAtmTcom=this.commissionCount.microatm_cash_withdrawl.commissionAfterTdsDecduction;
          this.mAtmGTV=(((this.commissionCount.microatm_cash_withdrawl.totalAmount)+((this.commissionCount.microatm_cash_withdrawl.totalAmountNeg)*-1))-this.commissionCount.microatm_cash_withdrawl.serviceCharges)
          this.mAtmTTds=this.commissionCount.microatm_cash_withdrawl.tdsAmount;
  
          this.APBCommission=this.commissionCount.aadharpay.commissionBeforeTDS;
          this.APCommission=this.commissionCount.aadharpay.commissionAfterTdsDecduction;
          this.APGTV= this.commissionCount.aadharpay.totalAmount+this.commissionCount.aadharpay.serviceCharges;
          this.TdsAP=this.commissionCount.aadharpay.tdsAmount;
  
          this.BbpsBCommission=this.commissionCount.bbps.commissionBeforeTDS;
          this.BbpsCommission=this.commissionCount.bbps.commissionAfterTdsDecduction;
          this.BbpsGTV= (((this.commissionCount.bbps.totalAmount)+((this.commissionCount.bbps.totalAmountNeg)*-1))-this.commissionCount.bbps.serviceCharges)
          this.TdsBbps=this.commissionCount.bbps.tdsAmount;
  
          this.CMSBCommission=this.commissionCount.cms.commissionBeforeTDS;
          this.CMSCommission=this.commissionCount.cms.commissionAfterTdsDecduction;
          this.CMSGTV= (((this.commissionCount.cms.totalAmount)+((this.commissionCount.cms.totalAmountNeg)*-1))-this.commissionCount.cms.serviceCharges)
          this.CMSTds=this.commissionCount.cms.tdsAmount;
  
          }
          else{
            if(data.error.message=="No Session Data Found" || data.error.message=="Invalid Authentication Token"){
              this.router.navigate(['']);
              localStorage.clear();
            }
            this.toastr.error(data.error.message);
          }
        
        },
        (errorData) => {}
      );
    }
    
  }
  dailyReportTotal(value){
    console.log("value::::::::::",value);
    if(value=='Today'){
      var startDate = new Date();
      this.startToday=moment(startDate).format("YYYY-MM-DD");
      console.log("today::::::",this.startToday)
      this.auth.getAllCommissionDistributorByDate(this.startToday,this.startToday).subscribe(
        (data: any) => {
          if(data.status_code==1){
          this.commissionCount=data.object
          
            this.totalBcomm =this.commissionCount.totalCommissionBeforeTDS
            this.totalcomm =this.commissionCount.totalCommissionAfterTdsDecduction
            this.totalTds =this.commissionCount.totalTdsAmount
            var AepsTGTV= (((this.commissionCount.aeps.totalAmount)+((this.commissionCount.aeps.totalAmountNeg)*-1))-this.commissionCount.aeps.serviceCharges)
            var DmtTGTV=(((this.commissionCount.dmt.totalAmount)+((this.commissionCount.dmt.totalAmountNeg)*-1))-this.commissionCount.dmt.serviceCharges)
            var mobileTGTV=(((this.commissionCount.mobileRecharge.totalAmount)+((this.commissionCount.mobileRecharge.totalAmountNeg)*-1))-this.commissionCount.mobileRecharge.serviceCharges)
            var dthTGTV=(((this.commissionCount.dthRecharge.totalAmount)+((this.commissionCount.dthRecharge.totalAmountNeg)*-1))-this.commissionCount.dthRecharge.serviceCharges)
            var mAtmTGTV=(((this.commissionCount.microatm_cash_withdrawl.totalAmount)+((this.commissionCount.microatm_cash_withdrawl.totalAmountNeg)*-1))-this.commissionCount.microatm_cash_withdrawl.serviceCharges)
            var APTGTV= this.commissionCount.aadharpay.totalAmount+this.commissionCount.aadharpay.serviceCharges;
            var BbpsTGTV=(((this.commissionCount.bbps.totalAmount)+((this.commissionCount.bbps.totalAmountNeg)*-1))-this.commissionCount.bbps.serviceCharges)
            var CMSGTV= (((this.commissionCount.cms.totalAmount)+((this.commissionCount.cms.totalAmountNeg)*-1))-this.commissionCount.cms.serviceCharges)
  
            this.totalGTVCurrectDay=AepsTGTV+DmtTGTV+mobileTGTV+dthTGTV+mAtmTGTV+APTGTV+BbpsTGTV+CMSGTV;
         
          console.log("this.dthTds+this.mobileTds::::::",this.dthTds,this.mobileTds,(this.dthTds+this.mobileTds));
          }
          else{
            if(data.error.message=="No Session Data Found" || data.error.message=="Invalid Authentication Token"){
              this.router.navigate(['']);
              localStorage.clear();
            }
            this.toastr.error(data.error.message);
          }
        
        },
        (errorData) => {}
      );
    }
    else if(value=='Last 7 Days'){
    
      var end = new Date();
      this.weekendDate = moment(end).format("YYYY-MM-DD");
  
      var startDate = new Date();
      startDate.setDate(end.getDate()-7)
      this.weekstartDateFormat = moment(startDate).format("YYYY-MM-DD");
     
       console.log("todaydate==",this.weekstartDateFormat,"yest:::",this.weekendDate)
       this.auth.getAllCommissionDistributorByDate(this.weekstartDateFormat,this.weekendDate).subscribe(
        (data: any) => {
          if(data.status_code==1){
          this.commissionCount=data.object
        
          this.totalBcomm = this.commissionCount.totalCommissionBeforeTDS
          this.totalcomm =this.commissionCount.totalCommissionAfterTdsDecduction
          this.totalTds =this.commissionCount.totalTdsAmount
          var AepsTGTV= (((this.commissionCount.aeps.totalAmount)+((this.commissionCount.aeps.totalAmountNeg)*-1))-this.commissionCount.aeps.serviceCharges)
          var DmtTGTV=(((this.commissionCount.dmt.totalAmount)+((this.commissionCount.dmt.totalAmountNeg)*-1))-this.commissionCount.dmt.serviceCharges)
          var mobileTGTV=(((this.commissionCount.mobileRecharge.totalAmount)+((this.commissionCount.mobileRecharge.totalAmountNeg)*-1))-this.commissionCount.mobileRecharge.serviceCharges)
          var dthTGTV=(((this.commissionCount.dthRecharge.totalAmount)+((this.commissionCount.dthRecharge.totalAmountNeg)*-1))-this.commissionCount.dthRecharge.serviceCharges)
          var mAtmTGTV=(((this.commissionCount.microatm_cash_withdrawl.totalAmount)+((this.commissionCount.microatm_cash_withdrawl.totalAmountNeg)*-1))-this.commissionCount.microatm_cash_withdrawl.serviceCharges)
          var APTGTV= this.commissionCount.aadharpay.totalAmount+this.commissionCount.aadharpay.serviceCharges;
          var BbpsTGTV=(((this.commissionCount.bbps.totalAmount)+((this.commissionCount.bbps.totalAmountNeg)*-1))-this.commissionCount.bbps.serviceCharges)
          var CMSGTV= (((this.commissionCount.cms.totalAmount)+((this.commissionCount.cms.totalAmountNeg)*-1))-this.commissionCount.cms.serviceCharges)
  
          this.totalGTVLastWeek=AepsTGTV+DmtTGTV+mobileTGTV+dthTGTV+mAtmTGTV+APTGTV+BbpsTGTV+CMSGTV;
  
              }
          else{
            if(data.error.message=="No Session Data Found" || data.error.message=="Invalid Authentication Token"){
              this.router.navigate(['']);
              localStorage.clear();
            }
            this.toastr.error(data.error.message);
          }
        
        },
        (errorData) => {}
      );
    }
    else if(value=='Current Month'){
      var currentdate = new Date();
      var cur_month = currentdate.getMonth() + 1;
      var cur_year = currentdate.getFullYear();
  
      this.MonthEnddate= moment(currentdate).format("YYYY-MM-DD");
      var std=cur_year+"-"+"0"+cur_month+"-"+'01'
      this.MonthStartDate=moment(std).format("YYYY-MM-DD")
      console.log(this.MonthEnddate,std,this.MonthStartDate);
  
      this.auth.getAllCommissionDistributorByDate(this.MonthStartDate,this.MonthEnddate).subscribe(
        (data: any) => {
          if(data.status_code==1){
          this.commissionCount=data.object
         
  
          this.totalBcomm =this.commissionCount.totalCommissionBeforeTDS
          this.totalcomm =this.commissionCount.totalCommissionAfterTdsDecduction
          this.totalTds =this.commissionCount.totalTdsAmount;
          var AepsTGTV= (((this.commissionCount.aeps.totalAmount)+((this.commissionCount.aeps.totalAmountNeg)*-1))-this.commissionCount.aeps.serviceCharges)
          var DmtTGTV=(((this.commissionCount.dmt.totalAmount)+((this.commissionCount.dmt.totalAmountNeg)*-1))-this.commissionCount.dmt.serviceCharges)
          var mobileTGTV=(((this.commissionCount.mobileRecharge.totalAmount)+((this.commissionCount.mobileRecharge.totalAmountNeg)*-1))-this.commissionCount.mobileRecharge.serviceCharges)
          var dthTGTV=(((this.commissionCount.dthRecharge.totalAmount)+((this.commissionCount.dthRecharge.totalAmountNeg)*-1))-this.commissionCount.dthRecharge.serviceCharges)
          var mAtmTGTV=(((this.commissionCount.microatm_cash_withdrawl.totalAmount)+((this.commissionCount.microatm_cash_withdrawl.totalAmountNeg)*-1))-this.commissionCount.microatm_cash_withdrawl.serviceCharges)
          var APTGTV= this.commissionCount.aadharpay.totalAmount+this.commissionCount.aadharpay.serviceCharges;
          var BbpsTGTV=(((this.commissionCount.bbps.totalAmount)+((this.commissionCount.bbps.totalAmountNeg)*-1))-this.commissionCount.bbps.serviceCharges)
          var CMSGTV= (((this.commissionCount.cms.totalAmount)+((this.commissionCount.cms.totalAmountNeg)*-1))-this.commissionCount.cms.serviceCharges)
  
          this.totalGTVLastMonth=AepsTGTV+DmtTGTV+mobileTGTV+dthTGTV+mAtmTGTV+APTGTV+BbpsTGTV+CMSGTV;
  
          
          }
          else{
            if(data.error.message=="No Session Data Found" || data.error.message=="Invalid Authentication Token"){
              this.router.navigate(['']);
              localStorage.clear();
            }
            this.toastr.error(data.error.message);
          }
        
        },
        (errorData) => {}
      );
    }
  }
}
